module.exports = require('./helpers/bundle-url').getBundleURL('cQT0O') + "compass-empty-state-card.055b7a63.svg";